export default {
    row1 : [
    {
        column: "column1",
        rows: {
            row1: [
                {
                    name: "landOverseasAgent",
                    checkboxLabel: "Overseas Agent",
                    component: "checkboxBox",

                },
            ],
        },
    },
]
};


